import { render, staticRenderFns } from "./MensagemForm.vue?vue&type=template&id=3f39e451&scoped=true&"
import script from "./MensagemForm.vue?vue&type=script&lang=js&"
export * from "./MensagemForm.vue?vue&type=script&lang=js&"
import style0 from "./MensagemForm.vue?vue&type=style&index=0&id=3f39e451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39e451",
  null
  
)

export default component.exports